<div class="card" id="comment-feature-card">
  <div class="card-block" *transloco="let loco; prefix: 'pages.comments'">
    <div class="card-text">
      <!-- Using numeric indices for tabs to avoid issues with language switching -->
      <clr-tabs>
        <!-- Tab 0: Urgent -->
        <clr-tab>
          <button clrTabLink
                  (click)="activeTab = 0">{{ loco('urgent') }}</button>
          <clr-tab-content *ngIf="activeTab === 0">
            <app-comment-list [commentType]=commentType [projectId]=projectId [companyId]=companyId
                              [staffId]=staffId [subId]=subId [status]=false [activeTab]="activeTab"
                              (activateParentTab)="activeTab = $event"></app-comment-list>
          </clr-tab-content>
        </clr-tab>
        <!-- Tab 1: Done -->
        <clr-tab>
          <button clrTabLink (click)="activeTab = 1">{{ loco('done') }}</button>
          <clr-tab-content *ngIf="activeTab === 1">
            <app-comment-list [commentType]=commentType [projectId]=projectId [companyId]=companyId
                              [staffId]=staffId [subId]=subId [status]=true [activeTab]="activeTab"
                              (activateParentTab)="activeTab = $event"></app-comment-list>
          </clr-tab-content>
        </clr-tab>
        <!-- Tab 2: Delete -->
        <clr-tab>
          <button clrTabLink (click)="activeTab = 2">{{ loco('delete') }}</button>
          <clr-tab-content *ngIf="activeTab === 2">
            <app-comment-list [commentType]=commentType [projectId]=projectId [companyId]=companyId
                              [staffId]=staffId [subId]=subId [status]=true [trash]="true" [activeTab]="activeTab"
                              (activateParentTab)="activeTab = $event"></app-comment-list>
          </clr-tab-content>
        </clr-tab>
      </clr-tabs>
    </div>
  </div>
</div>
